<template>
    <div>
        <div id="menuperfil" class="container mt-3">
            <div class="text-center mb-3">
                <span style="font-size: larger;">Peril</span>
            </div>
            <div class="text-center mb-3">
                <!-- <img class="img-profile" src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt=""> -->
                <div class="text-center mb-3 position-relative img-wrapper" @click="$refs.if_imgcliente.click()">
                    <input type="file" id="ipselecionarimgcliente" accept="image/png, image/jpeg"
                        @change="mtdselecionarimagemcliente" style="display: none;" ref="if_imgcliente">

                    <img v-if="foto !== ''" class="img-profile" :src="foto" alt="">
                    <img v-else class="img-profile"
                        src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
                        alt="">
                    <div class="img-overlay d-flex flex-column justify-content-center align-items-center">
                        <i class="bi bi-pencil-fill animate-pencil"></i>
                        <small class="text-white mt-1">Clique para mudar</small>
                    </div>
                </div>

            </div>

            <div class="row g-3">
                <div class="col-12 col-sm-6" v-for="item in menuItems" :key="item.id">
                    <li class="list-group-item list-group-item-action border rounded p-0"
                        @click.prevent="mtdabrirtela(item.tela)">
                        <div class="card h-100" style="background-color: #212529;">
                            <div class="container py-3">
                                <div class="row">
                                    <div class="col-2 text-center d-flex align-items-center justify-content-center">
                                        <i :class="item.icone" style="font-size: 30px;"></i>
                                    </div>
                                    <div class="col-10">
                                        <span class="tit-item-menu-ve d-block text-white">{{ item.titulo }}</span>
                                        <small class="sub-tit-item-menu-ve text-muted d-block">{{ item.subtitulo
                                        }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </div>
            </div>
        </div>

        <div id="conteudoperfil" class="container mt-4">
            <div v-if="migrapremium">
                <migrapremiumcmp />
            </div>
            <div v-if="editardados">
                <editardados />
            </div>
            <div v-if="integracao">
                <integracao />
            </div>
         
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import util from './util.js';
import migrapremiumcmp from './perfil/migrapremium.vue'
import editardados     from './perfil/editardados.vue'
import integracao   from './perfil/integracao.vue'
import cadmetas        from './cruds/cadmetas.vue'

export default {
    name: 'menusis',
    components: {
       
        migrapremiumcmp,
        editardados,
        integracao,
        cadmetas
    },
    data() {
        return {
            migrapremium: false,
            editardados: false,
            integracao: false,
            foto: '',
            menuItems: [
                // {
                //     id: 1,
                //     titulo: 'Migrar para o premium',
                //     subtitulo: 'Veja as vantagens',
                //     icone: 'bi bi-suit-spade',
                //     tela: 'migrapremium'
                // },
                {
                    id: 2,
                    titulo: 'Editar dados',
                    subtitulo: 'Informações pessoais e etc.',
                    icone: 'bi bi-pencil-square',
                    tela: 'editardados'
                },
                {
                    id: 3,
                    titulo: 'Integração',
                    subtitulo: 'Amazon alexa e whatsApp',
                    icone: 'bi bi-plugin',
                    tela: 'integracao'
                },
                {
                    id: 4,
                    titulo: 'Sair',
                    subtitulo: 'Encerrar sessão',
                    icone: 'bi bi-box-arrow-right',
                    tela: 'sair'
                }
            ]
        }
    },
    methods: {
        mtdselecionarimagemcliente(event) {
            let vself = this;
            let arq = event.target.files[0];
           
            let parametros = [
                { parametro: 'arquivo',     valor: arq },
                { parametro: 'op', valor:   'mudarfoto' },
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
            retorno.then(function (response) {
                if($.isNumeric(response.data.inf)){
                    vself.foto = response.data.foto;
                    localStorage.setItem('foto', vself.foto);
                }
             
                $('#ipselecionarimgcliente').val('');
              
            }).catch(function (response) {
             
                $('#ipselecionarimgcliente').val('');
            });
        },
        mtdabrirtela(tela) {
            $('#menuperfil').hide();
            this.fechatelas();

            if (tela == 'sair') {
                localStorage.clear();
                location.reload();
            }
            this[tela] = true;
            $('#conteudoperfil').fadeIn(700);
        },
        fechatelas() {
            this.migrapremium = false;
            this.editardados  = false;
            this.integracao   = false;
        }
    },
    mounted() {
        this.foto = localStorage.getItem('foto');
    }
}
</script>

<style scoped>
.sub-tit-item-menu-ve {
    font-size: 0.75rem;
}

.tit-item-menu-ve {
    font-weight: 600;
    color: white;
}

@media (max-width: 576px) {
    .tit-item-menu-ve {
        font-size: 0.9rem;
    }

    .sub-tit-item-menu-ve {
        font-size: 0.65rem;
    }
}

.img-wrapper {
    display: inline-block;
    position: relative;
    width: 200px;
    height: 200px;
    border-radius: 100%;
    overflow: hidden;
    border: 4px solid #7b8ab3;
    /* Borda azul destaque */
    cursor: pointer;
    transition: border-color 0.3s;
}

.img-wrapper:hover {
    border-color: #7b8ab3;
}

.img-profile {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 100%;
}

.img-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(33, 37, 41, 0.6);
    /* fundo escuro semi-transparente */
    opacity: 0;
    transition: opacity 0.3s;
    border-radius: 100%;
    color: white;
    text-align: center;
}

.img-wrapper:hover .img-overlay {
    opacity: 1;
}

.animate-pencil {
    font-size: 24px;
    animation: bounce 1.2s infinite;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-4px);
    }
}
</style>
